import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const go = (d) => setIdx((i) => (i + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[idx];

  return (
    <section className="bg-dq-bg py-20 lg:py-28" data-testid="testimonials-section">
      <div className="dq-container">
        <SectionHeader
          center
          eyebrow="Client love"
          title="Businesses that grew with"
          highlight="DiziTeQ"
          subtitle="Real results from real Bengaluru businesses."
        />

        <div className="relative mx-auto mt-14 max-w-3xl">
          <div className="relative overflow-hidden rounded-[2rem] border border-dq-line bg-white p-8 dq-shadow-soft sm:p-12">
            <Quote className="absolute right-8 top-8 h-16 w-16 text-dq-orange/10" />
            <AnimatePresence mode="wait">
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
                data-testid="testimonial-card"
              >
                <div className="flex gap-0.5 text-dq-orange">
                  {[...Array(t.rating)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" />)}
                </div>
                <p className="mt-6 font-display text-xl font-semibold leading-snug text-dq-ink sm:text-2xl">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <span className="grid h-14 w-14 place-items-center rounded-full bg-dq-orange/10 font-display text-lg font-extrabold text-dq-orange">
                    {t.name.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                  </span>
                  <div>
                    <div className="font-display font-bold text-dq-ink">{t.name}</div>
                    <div className="text-sm text-dq-muted">{t.business} · {t.industry}</div>
                  </div>
                  <span className="ml-auto rounded-full bg-dq-success/10 px-3 py-1.5 text-sm font-bold text-dq-success">
                    {t.result}
                  </span>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-8 flex items-center justify-center gap-4">
            <button onClick={() => go(-1)} data-testid="testimonial-prev" aria-label="Previous"
              className="grid h-11 w-11 place-items-center rounded-full border border-dq-line bg-white text-dq-ink transition-colors hover:border-dq-ink">
              <ChevronLeft className="h-5 w-5" />
            </button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button key={i} onClick={() => setIdx(i)} aria-label={`Go to testimonial ${i + 1}`}
                  className={`h-2 rounded-full transition-all duration-300 ${i === idx ? "w-7 bg-dq-orange" : "w-2 bg-dq-line"}`} />
              ))}
            </div>
            <button onClick={() => go(1)} data-testid="testimonial-next" aria-label="Next"
              className="grid h-11 w-11 place-items-center rounded-full border border-dq-line bg-white text-dq-ink transition-colors hover:border-dq-ink">
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
